//aspect ratio

import { ImageLoaderConfig } from '@angular/common';
import { ImageProcessorConfig } from './models';

//https://github.com/angular/angular/pull/51951
function seperator(url: string) {
  return url.indexOf('?') >= 0 ? '&' : '?';
}

function aspectRatio(width: number, height: number): number {
  if (!height || !width) {
    return 0;
  }

  return height / width;
}

export function transform(config: ImageLoaderConfig, processorConfig: ImageProcessorConfig): string {
  if (!config.src) {
    return config.src;
  }

  let val = `${config.src.replaceAll(' ', '%20')}`;

  const originalHeight = config.loaderParams?.['height'];
  const originalWidth = config.loaderParams?.['width'];

  // Array of options for our image processor
  const availableStandardOptions = Object.keys(processorConfig.options);

  // console.log('[INPUT] Image transform ', config, processorConfig);

  if (!config.width) {
    if (originalHeight) {
      val = `${val}${seperator(val)}${processorConfig.options.height}=${originalHeight}`;
      availableStandardOptions.splice(availableStandardOptions.indexOf('height'), 1); // remove height from options as it is already applied
    }
    if (originalWidth) {
      val = `${val}${seperator(val)}${processorConfig.options.width}=${originalWidth}`;
    }
  } else {
    // Width changes with every ngSrcset size, so directly apply it
    val = `${val}${seperator(val)}${processorConfig.options.width}=${config.width}`;
  }

  availableStandardOptions.splice(availableStandardOptions.indexOf('width'), 1); // already applied width from config/srcset

  const ratio = aspectRatio(originalWidth, originalHeight);

  availableStandardOptions.forEach(option => {
    if (!config.loaderParams?.[option] || Object.keys(processorConfig.options).indexOf(option) === -1) {
      return;
    }

    // Custom calculate height based on aspect ratio and new width
    if (option === 'height' && config.width) {
      val = `${val}${seperator(val)}${option}=${Math.round(ratio * config.width)}`;
      return;
    }

    if (option === 'anchor') {
      val = `${val}${seperator(val)}${(<any>processorConfig.options)[option]}=${processorConfig.parseAnchor(config.loaderParams?.[option])}`;
      return;
    }

    if (option === 'other') {
      val = `${val}${seperator(val)}${config.loaderParams?.[option]}`;
      return;
    }

    val = `${val}${seperator(val)}${(<any>processorConfig.options)[option]}=${config.loaderParams?.[option]}`;
  });

  // console.log('[OUTPUT] Image transform', val);
  return val;
}

//https://docs.imageflow.io/querystring/introduction.html
